import React from "react";
import Form from "react-bootstrap/form";

function DivisionsSelect({ onChange, options }) {
  const divisions = options || [
    { name: "All", value: "" },
    { name: "Ashland", value: "Ashland" },
    { name: "Aurora", value: "Aurora" },
    { name: "Birmingham", value: "Birmingham" },
    { name: "Boulder", value: "Boulder" },
    { name: "Bowling Green", value: "Bowling Green" },
    { name: "Canton", value: "Canton" },
    { name: "Charleston", value: "Charleston" },
    { name: "Cincinnati", value: "Cincinnati" },
    { name: "Cleveland", value: "Cleveland" },
    { name: "Colorado Springs", value: "Colorado Springs" },
    { name: "Columbia", value: "Columbia" },
    { name: "Columbus", value: "Columbus" },
    { name: "Dayton", value: "Dayton" },
    { name: "Elizabethtown", value: "Elizabethtown" },
    { name: "Findlay", value: "Findlay" },
    { name: "Fort Collins", value: "Fort Collins" },
    { name: "Fort Wayne", value: "Fort Wayne" },
    { name: "Greeley", value: "Greeley" },
    { name: "Greenville", value: "Greenville" },
    { name: "Huntsville", value: "Huntsville" },
    { name: "Indianapolis", value: "Indianapolis" },
    { name: "Las Vegas", value: "Las Vegas" },
    { name: "Lexington", value: "Lexington" },
    { name: "Louisville", value: "Louisville" },
    { name: "Merrillville", value: "Merrillville" },
    { name: "Mishawaka", value: "Mishawaka" },
    { name: "Montgomery", value: "Montgomery" },
    { name: "Northern Kentucky", value: "Northern Kentucky" },
    { name: "Pickens", value: "Pickens" },
    { name: "Sidney", value: "Sidney" },
    { name: "Somerset", value: "Somerset" },
    { name: "Southern IN", value: "Southern IN" },
  ];

  return (
    <Form.Group>
      <label htmlFor="divisions" className="form-label">
        Divisions
      </label>
      <select
        name="divisions"
        id="divisions"
        className="form-control"
        onChange={(e) => onChange(e.currentTarget.value)}
      >
        {divisions.map((option, index) => (
          <option key={`divisions.${index}`} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </Form.Group>
  );
}

export default DivisionsSelect;
